import React from 'react';
import TopHeader from '../components/TopHeader';
import Success from '../components/sucess';

const handleReturn = () => {
  window.location.href = '/compte/rendez-vous';
}
const successEditRdv = () => {

  return (
    <div className="success-page" style={{ backgroundColor: '#F6F6F6', minHeight: '100vh' }}>
      <TopHeader btn={true} />
      <Success 
          title="Modification confirmée" 
          message="Vous pouvez voir le détail de votre rendez vous dans votre compte." 
          buttonText="Retourner à mon compte" 
          onReturn={handleReturn} 
        />
     
    </div>
  );
};

export default successEditRdv;